
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import Swal from "sweetalert2";
import CityResponse from "@/models/WsdlResponses/CityResponse";
import ZoneResponse from "@/models/WsdlResponses/ZoneResponse";
import OccupationResponse from "@/models/WsdlResponses/OccupationResponse";
import TypeResponse from "@/models/WsdlResponses/TypeResponse";
import UserResponse from "@/models/WsdlResponses/UserResponse";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import Option from "@/models/SelectOption";
import Reclamacion from "@/models/SolicitudReclamaciones/Reclamacion";
import AfiliadoService from "@/services/AfiliadoService";
import SolicitudReclamacionesModel from "@/models/SolicitudReclamaciones/SolicitudReclamacionesModel";

@Component({})
export default class SolicitudReclamacionesForm extends Vue {
	@Prop() isProcessing: boolean;
	
    public email: string = this.$store.state.user.correoElectronico1;
    public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    public userId: string = this.$store.state.user.cedula;
	public user: UserResponse = new UserResponse();
	public labelData: SolicitudReclamacionesModel = new SolicitudReclamacionesModel();
    public cities: Array<Option<CityResponse>> = [];
    public zones: Array<Option<ZoneResponse>> = [];
    public occupations: Array<Option<OccupationResponse>> = [];
    public motives: Array<Option<TypeResponse>> = [];
    public communicationSources: Array<Option<TypeResponse>> = [];
    public city: CityResponse = null;
    public zone: ZoneResponse = null;
    public occupation: OccupationResponse = null;
    public motive: TypeResponse = null;
    public communicationSource: TypeResponse = null;
    public wsdlService: WsdlService = new WsdlService();
    public umbracoService: UmbracoApiService = new UmbracoApiService();
    public tipoFondo: FundTypeObj = new FundTypeObj();
	public afiliadoService: AfiliadoService = new AfiliadoService();
    public complaintForm: Reclamacion = new Reclamacion();
	public isValidating: boolean = false;

    public async mounted() {
		await this.getLabels();
		await this.getUserData(this.userId);
        await this.getCities();
        await this.getOccupations();
        await this.getMotives();
        await this.getTypes();
		await this.getUserFundType();

    }
	public getLabels(){
		this.umbracoService.getSolicitudReclamaciones().then(response => {
			this.labelData = response;
		})
	}
	public async getUserFundType(){
		this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                this.tipoFondo = response.data;
            });
	}
	public async setDefaultUserValuesInForm(){
		this.complaintForm.cod_usuario = this.userId;
		this.complaintForm.email_usuario = this.email;
		let ip = (await this.afiliadoService.getUserIpAddress()).data.ip;
		this.complaintForm.ip_cliente =  ip;
		this.complaintForm.code_tel_casa =  this.user.codetelcasa;
		this.complaintForm.tel_residencia =  this.user.telcasa;
		this.complaintForm.code_tel_celular =  this.user.codecelular;
		this.complaintForm.tel_celular =  this.user.celular;
		this.complaintForm.dir_permanente1 =  this.user.domiciliO1;
		this.complaintForm.des_domicilio1 =  this.user.numerO1;
		this.complaintForm.des_edificio1 =  this.user.edificiO1;
		this.complaintForm.des_apto1 =  this.user.aptO1;
		this.complaintForm.cod_ciudad1 =  this.user.codciudaD1;
		this.complaintForm.cod_sector1 =  this.user.codsectoR1;
		this.complaintForm.ciudad1 =  this.user.ciudad;
		this.complaintForm.sector1 =  this.user.sector;
		this.complaintForm.cod_persona =  this.user.codpersona;
	}
	public getUserData(userId: string){
		this.wsdlService.getUserData(userId).then((resp: AxiosResponse<any>) => {
			this.user = resp.data;
		})
	}
	public validRNC(rnc: string) : boolean {
		let isNan = !isNaN(parseInt(rnc));
		return (rnc.length < 9 && isNan) 
	}
    public getCities(city: string = "") {
        this.wsdlService
            .GetCiudades(city)
            .then((response: AxiosResponse<Array<CityResponse>>) => {
                this.cities = response.data.map((respObj: CityResponse) => ({
                    value: respObj,
                    text: respObj.descripcion,
                    disabled: false,
                }));
            });
    }
	public toPhoneFormat(phoneNumber: string) : string{
		if(!phoneNumber){
			return "";
		}
		let firstThreeNumbers = phoneNumber.substring(0, 3);
		let lastFourNumbers = phoneNumber.substring(3, phoneNumber.length);
		return `${firstThreeNumbers}-${lastFourNumbers}`;
	}
    public getZones(city: string, zone: string = "") {
        this.wsdlService
            .GetSectores(city, zone)
            .then((response: AxiosResponse<Array<ZoneResponse>>) => {
                this.zones = response.data.map((respObj: ZoneResponse) => ({
                    value: respObj,
                    text: respObj.descripcion,
                    disabled: false,
                }));
            });
    }

    public getOccupations() {
        this.wsdlService
            .GetCargos("")
            .then((response: AxiosResponse<Array<OccupationResponse>>) => {
                this.occupations = response.data.map(
                    (respObj: OccupationResponse) => ({
                        value: respObj,
                        text: respObj.descripcion,
                        disabled: false,
                    })
                );
            });
    }
    public getMotives() {
        this.wsdlService
            .GetTipoDegestion("")
            .then((response: AxiosResponse<Array<TypeResponse>>) => {
                this.motives = response.data.map((respObj: TypeResponse) => ({
                    value: respObj,
                    text: respObj.descripcion,
                    disabled: false,
                }));
            });
    }
    public getTypes() {
        this.wsdlService
            .GetGestion("")
            .then((response: AxiosResponse<Array<TypeResponse>>) => {
                this.communicationSources = response.data.map(
                    (respObj: TypeResponse) => ({
                        value: respObj,
                        text: respObj.descripcion,
                        disabled: false,
                    })
                );
            });
    }
    public cleanForm() {
        this.complaintForm = new Reclamacion();
		this.city = null;
		this.zone = null;
		this.occupation = null;
		this.motive = null;
		this.communicationSource = null;
		this.isValidating = false;

    }
	public isFormValid() : boolean{
		const isFormValid = (this.complaintForm.razon_social !== "" && 
		this.complaintForm.id_rnc !== "" &&
		this.complaintForm.dir_permanente2 !== "" &&
		this.complaintForm.des_domicilio2 !== "");
		const validObj = !(!this.city &&
		!(this.zone || this.zones.length <= 0) &&
		!this.occupation &&
		!this.motive &&
		!this.communicationSource)
		return isFormValid && validObj;
	}
    public async process() {
		if(this.isFormValid()){
			Swal.fire({
				title: "",
				text: "¿Desea enviar la solicitud?",
				icon: "warning",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				confirmButtonColor: "#ED8B2F",
				cancelButtonColor: "#0F6CBC",
				confirmButtonText: "OK",
				reverseButtons: true,
			}).then((result) => {
				if(result.isConfirmed){
					this.complaintForm.cod_cuenta =  this.tipoFondo.tipofondos.codcuenta; // get pot tipo de cuenta
					this.complaintForm.tipo_fondo =  this.tipoFondo.tipofondos.tipofondo; // get pot tipo de cuenta
					this.complaintForm.cod_ciudad2 =  this.city.ciudad; // cod ciudad form
					this.complaintForm.cod_sector2 =  this.zone.sector; //cod sector form
					this.complaintForm.ciudad2 =  this.city.descripcion; // ciudad form
					this.complaintForm.sector2 =  this.zone.descripcion; // sector form
					this.complaintForm.ind_via_respuesta =  this.communicationSource.tipRespuesta; // via respuesta form
					this.complaintForm.ind_via_recepcion =  this.tipoFondo.tipofondos.tipenvio;
					this.complaintForm.cod_cargo =  this.occupation.codCargo; // ocupacion form
					this.complaintForm.tip_gestion =  this.motive.tipGestion;

					this.complaintForm.ind_estado =  this.communicationSource.tipRespuesta; // revisar 
					this.complaintForm.id_nss =  '10786159'; // revisar
					this.complaintForm.cod_empresa_cta =  this.tipoFondo.tipofondos.tipofondo; //revisar
					this.$emit("process", this.complaintForm);
				}
			});
			
		}
		else{
			this.isValidating = true;

			Swal.fire({
				text: "Debe llenar todos los campos requeridos.",
				icon: "error",
				showConfirmButton: true,
				confirmButtonText: "Ok",
				onClose: () => {
					
				}
			});
		}

    }
    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
    @Watch("city")
    public async onCityChange(value: CityResponse) {
        await this.getZones(value.ciudad);
    }
}
